import currentEnv from "@/app/config/environment";
import { POST } from "@/app/services/apiService";
import { getDataFromSessionStorage, saveDataToSessionStorage} from "@/app/services/storageService";
import { getBrowserInfo } from "@/app/services/utilService";
import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from 'uuid';

export async function logoutUser({ data = {} }) {
    const config = { url: 'accounts/signout', data, headers: { 'x-platform': 'web' } };
    const response = await POST(config);
    return response;
}

export async function registerDevice(deviceToken:string) {
    const browser = await getBrowserInfo();
	let deviceId = getDataFromSessionStorage('device_id');

	if (!deviceId) {
		deviceId = uuidv4();
		saveDataToSessionStorage('device_id', deviceId);
	}
	const reqBody: any = {
		deviceToken: deviceToken,
		deviceId: deviceId,
		deviceName: browser.name,
		appVersion: currentEnv.latestAppVersion,
		osName: browser.os,
		osVersion: browser.version,
		platform: 'web',
	};
	const req = { url: 'users/devices', data: reqBody, headers: { 'x-platform': 'web' } };
	const res: any = await POST(req);
	return res;
}

const initialState: any = {
    userProfile: null,
    featurePermission: null,
    titleParams: null
};

export const authReducer = createSlice({
    name: "auth",
    initialState,
    reducers: {
        saveAuthUser: (state, action) => {
            state.userProfile = action.payload;

        },
        saveFeaturePermission: (state, action) => {
            state.featurePermission = action.payload;
        },
        removeAuthUser: (state) => {
            state.userProfile = null;
        },
        updateTitleParams: (state, action) => {
            state.titleParams = action.payload;
        },
    },
});

export const { saveAuthUser, removeAuthUser, saveFeaturePermission, updateTitleParams } = authReducer.actions;
export default authReducer.reducer;

